;(function($){

    function Contact() {
        var _ = this;

        $.validator.addMethod("valueNotEquals", function(value, element, arg){
          return arg != value;
        }, "Value must not equal arg.");

        var $myForm = $("#event-form").validate({
            rules: {
                category: { valueNotEquals: "0" },
                name: { required: true },
                email: { required: true, email: true },
                cpf: { required: true },
                phone: { required: true },
                birthdate: { required: true },
                text: { required: true }
            },
            messages: {
                category: { valueNotEquals: "Informe a categoria do contato" },
                name: { required: "Informe seu nome" },
                email: { required: 'Informe o seu email', email: 'Ops, informe um email válido' },
                cpf: { required: "Informe o nº do seu cpf" },
                phone: { required: "Informe o nº do seu telefone" },
                birthdate: { required: "Informe a data de nascimento" },
                text: { required: "Insira uma descrição" }
            },
            
            submitHandler: function( form ) {
                
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: $("#app_url").val() + "/api/contato-de-eventos",
                    data: $( form ).serialize(),
                    success: function(result)
                    {
                       swal("Contato enviado com sucesso!", "Em breve nosso atendimento retornará o seu contato.", "success")
                       form.reset();
                       grecaptcha.reset();
                    },
                    error: function(response) {
                        console.log(response);
                        swal("Atenção!", "por favor marque o campo captcha!", "error")
                    }
                });
            }
        }); 
    }

    new Contact();

}(jQuery));
